import { cn } from "../../lib/utils";
import { useChartTooltipRowContext } from "./ChartTooltipContext";

export interface ChartTooltipIndicatorProps {
  className?: string;
}

/** A row's series marker: the config icon when one is set, else a square in the series color. */
export const ChartTooltipIndicator = ({ className }: ChartTooltipIndicatorProps) => {
  const { icon: Icon, indicatorColor } = useChartTooltipRowContext();
  if (Icon) return <Icon />;
  return (
    <div
      data-slot="chart-tooltip-indicator"
      className={cn("h-2.5 w-2.5 shrink-0 rounded-[2px]", className)}
      style={{ backgroundColor: indicatorColor }}
    />
  );
};
